<template>
    <footer class="py-6 text-center">
        <p class="mb-3 fw-light fs-24">Connect with us</p>
        <div class="d-flex align-items-center justify-content-center">
            <a target="_blank" href="https://twitter.com/hadanft" class="icon mx-2 rounded-circle d-flex align-items-center justify-content-center text-decoration-none text-white bg-secondary">
                <svg height="32" width="32">
                    <use xlink:href="#twitter-icon"></use>
                </svg>
            </a>
            <a target="_blank" href="https://medium.com/@hadanft" class="icon mx-2 rounded-circle d-flex align-items-center justify-content-center text-decoration-none text-white bg-secondary">
                <svg height="32" width="32">
                    <use xlink:href="#medium-icon"></use>
                </svg>
            </a>
            <a target="_blank" href="https://discord.gg/ZtktFrVshE" class="icon mx-2 rounded-circle d-flex align-items-center justify-content-center text-decoration-none text-white bg-secondary">
                <svg height="32" width="32">
                    <use xlink:href="#discord-icon"></use>
                </svg>
            </a>
            <a href="mailto:hadanft@protonmail.com" class="icon mx-2 rounded-circle d-flex align-items-center justify-content-center text-decoration-none text-white bg-secondary">
                <svg height="32" width="32">
                    <use xlink:href="#envelope-icon"></use>
                </svg>
            </a>
        </div>

        <div class="d-flex justify-content-center mt-6">
            <a target="_blank" :href="route('privacy-policy')" class="text-white"> Privacy Policy</a>
            <p class="mx-3">|</p>
            <a target="_blank" :href="route('cookie-policy')" class="text-white"> Cookie Policy</a>
            <p class="mx-3">|</p>
            <a target="_blank" :href="route('terms')" class="text-white"> Terms & Conditions</a>
        </div>
        <p class="mb-0 mt-5 fs-14 text-grey-200">&copy; {{ new Date().getFullYear() }} HadaNFT.com</p>
    </footer>
</template>

<script>
export default {
	name: 'FooterComponent'
}
</script>

<style scoped>
.icon {
    height: 52px;
    width: 52px;
}
</style>
